var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_125273",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_125273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16.0002C14.5334 16.0002 13.2778 15.4779 12.2334 14.4335C11.1889 13.3891 10.6667 12.1335 10.6667 10.6668C10.6667 9.20016 11.1889 7.94461 12.2334 6.90016C13.2778 5.85572 14.5334 5.3335 16 5.3335C17.4667 5.3335 18.7223 5.85572 19.7667 6.90016C20.8112 7.94461 21.3334 9.20016 21.3334 10.6668C21.3334 12.1335 20.8112 13.3891 19.7667 14.4335C18.7223 15.4779 17.4667 16.0002 16 16.0002ZM5.33337 26.6668V22.9335C5.33337 22.1779 5.52782 21.4835 5.91671 20.8502C6.3056 20.2168 6.82226 19.7335 7.46671 19.4002C8.84449 18.7113 10.2445 18.1946 11.6667 17.8502C13.0889 17.5057 14.5334 17.3335 16 17.3335C17.4667 17.3335 18.9112 17.5057 20.3334 17.8502C21.7556 18.1946 23.1556 18.7113 24.5334 19.4002C25.1778 19.7335 25.6945 20.2168 26.0834 20.8502C26.4723 21.4835 26.6667 22.1779 26.6667 22.9335V26.6668H5.33337ZM8.00004 24.0002H24V22.9335C24 22.6891 23.9389 22.4668 23.8167 22.2668C23.6945 22.0668 23.5334 21.9113 23.3334 21.8002C22.1334 21.2002 20.9223 20.7502 19.7 20.4502C18.4778 20.1502 17.2445 20.0002 16 20.0002C14.7556 20.0002 13.5223 20.1502 12.3 20.4502C11.0778 20.7502 9.86671 21.2002 8.66671 21.8002C8.46671 21.9113 8.3056 22.0668 8.18337 22.2668C8.06115 22.4668 8.00004 22.6891 8.00004 22.9335V24.0002ZM16 13.3335C16.7334 13.3335 17.3612 13.0724 17.8834 12.5502C18.4056 12.0279 18.6667 11.4002 18.6667 10.6668C18.6667 9.9335 18.4056 9.30572 17.8834 8.7835C17.3612 8.26127 16.7334 8.00016 16 8.00016C15.2667 8.00016 14.6389 8.26127 14.1167 8.7835C13.5945 9.30572 13.3334 9.9335 13.3334 10.6668C13.3334 11.4002 13.5945 12.0279 14.1167 12.5502C14.6389 13.0724 15.2667 13.3335 16 13.3335Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/Student.a9b0f35173c88f71ae4042d87fbaa7bd.svg";
export { ForwardRef as ReactComponent };